import { StepButton, StepIconProps, styled } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';

import './stepperComponent-styles.css';

export type Step = {
    label: string;
    completed: boolean;
    form: React.ReactElement;
};
interface IStepperComponentProps {
    stepsList: Step[];
    activeStep: number;
    handleNext?: () => void;
    optionalSteps?: number[];
    boxStyling?: BoxProps;
    showStepLabel?: boolean;
    setActiveStep?: (stepIndex) => void;
}

const SummaryStepIconRoot = styled('span')<{
    ownerState: { active?: boolean };
}>(({ ownerState }) => ({
    width: '74px',
    height: '24px',
    border: '1px solid #666666',
    borderRadius: '64px',
    padding: '0px 14px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '12px',
    color: '#575757',
    ...(ownerState.active && {
        border: 'none',
        backgroundColor: '#F18F34',
        color: 'white',
    }),
}));

const SummaryStepIcon = (props: StepIconProps) => {
    const { active, className } = props;

    return (
        <SummaryStepIconRoot ownerState={{ active }} className={className}>
            Summary
        </SummaryStepIconRoot>
    );
};

export const StepperComponent = ({
    stepsList,
    activeStep,
    boxStyling,
    showStepLabel = true,
    setActiveStep,
}: IStepperComponentProps) => {
    const returnStep = (showLabel, labelProps, label, currentIndex, lastIndex) => {
        if (showLabel) {
            if (currentIndex === lastIndex) {
                return (
                    <StepLabel
                        data-testid="add-partner-stepper-step-label"
                        {...labelProps}
                        StepIconComponent={SummaryStepIcon}
                    />
                );
            }
            return <StepLabel {...labelProps}>{label}</StepLabel>;
        } else if (currentIndex === lastIndex) {
            return (
                <StepLabel
                    data-testid="add-partner-stepper-step-label"
                    {...labelProps}
                    StepIconComponent={SummaryStepIcon}
                ></StepLabel>
            );
        }

        return (
            <StepLabel data-testid="add-partner-stepper-step-label" {...labelProps}>
                {activeStep === currentIndex || currentIndex === lastIndex ? label : null}
            </StepLabel>
        );
    };

    return (
        <Box
            {...boxStyling}
            sx={{
                width: '100%',
                padding: '24px 48px',
                border: '1px solid #F3A256',
                borderRadius: '16px',
                color: '#F3A256',
            }}
        >
            <Stepper activeStep={activeStep} nonLinear>
                {stepsList?.map((step, index) => {
                    const labelProps: {
                        optional?: React.ReactNode;
                    } = {};

                    return (
                        <Step key={step.label} completed={step.completed}>
                            <StepButton
                                data-testid="add-partner-stepper-step-button"
                                color="inherit"
                                onClick={() => setActiveStep(index)}
                            >
                                {returnStep(
                                    showStepLabel,
                                    labelProps,
                                    step.label,
                                    index,
                                    stepsList.length - 1
                                )}
                            </StepButton>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    );
};
